import GeminiCampaignModel from './GeminiCampaignModel';
import ExportModel from '../../lib/ExportModel';

export default {
  async getConfig(account) {
    // Create Campaign Model
    const campaignModel = new GeminiCampaignModel(account);
    return ExportModel(campaignModel);
  },
};
